import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { IconPlayArrow16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import { BlurContainer } from '../BlurContainer';
import * as styles from './Video.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Video = function Video(props) {
  var _props$backgroundSize = props.backgroundSize,
      backgroundSize = _props$backgroundSize === void 0 ? 'cover' : _props$backgroundSize,
      blurBackground = props.blurBackground,
      priority = props.priority;
  var previewUrl = getVideoPreview(props);
  var optimizationProps = React.useMemo(function () {
    if (priority) {
      return {
        fetchpriority: 'high'
      };
    }

    return {
      decoding: 'async',
      loading: 'lazy'
    };
  }, [priority]);
  return /*#__PURE__*/_jsxs(BlurContainer, _objectSpread(_objectSpread({
    enabled: blurBackground,
    background: previewUrl
  }, optimizationProps), {}, {
    children: [previewUrl && /*#__PURE__*/_jsx("img", _objectSpread({
      src: previewUrl,
      className: styles['preview'],
      style: {
        objectFit: backgroundSize
      }
    }, optimizationProps)), /*#__PURE__*/_jsx("div", {
      className: styles['icon-container'],
      children: props.playButton || /*#__PURE__*/_jsx("div", {
        className: styles['play-button'],
        children: /*#__PURE__*/_jsx(IconPlayArrow16, {
          color: "primary_100"
        })
      })
    })]
  }));
};
var YOUTUBE_LINK_REGEX = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;

function getVideoPreview(_ref) {
  var previewUrl = _ref.previewUrl,
      src = _ref.src;

  if (previewUrl) {
    return previewUrl;
  }

  var srcMatch = YOUTUBE_LINK_REGEX.exec(src);

  if (!srcMatch) {
    return null;
  }

  return "https://img.youtube.com/vi/".concat(srcMatch[1], "/hqdefault.jpg");
}